export default [
  {
    path: "/comex/hold-co",
    name: "comexholdco",
    component: () => import("@/views/comex/holdco.vue"),
    meta: {
      pageTitle: "Comex Hold Co",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Comex Hold Co",
          active: true,
        },
      ],
      resource: "Comex Hold Co",
      action: "menu",
    },
  },
  {
    path: "/comex/comercial_precios",
    name: "comercialprecios",
    component: () => import("@/views/comex/comercial_precios.vue"),
    meta: {
      pageTitle: "Commercial Prices",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Precios Comercial",
          active: true,
        },
      ],
      resource: "Precios Comercial",
      action: "menu",
    },
  },
  {
    path: "/comex/shipping-program",
    name: "shippingprogram",
    component: () => import("@/views/comex/shipping_new.vue"),
    meta: {
      pageTitle: "Shipping Program",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Shipping Program",
          active: true,
        },
      ],
      resource: "Shipping Program",
      action: "menu",
    },
  },
  {
    path: "/comex/shipping-advice",
    name: "shippingadvice",
    component: () => import("@/views/comex/shipping_advice.vue"),
    meta: {
      pageTitle: "Shipping Advice",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Shipping Advice",
          active: true,
        },
      ],
      resource: "Shipping Advice",
      action: "menu",
    },
  },
  {
    path: "/comex/shipping-emails",
    name: "correosenviados",
    component: () => import("@/views/comex/shipping_emails.vue"),
    meta: {
      pageTitle: "Shipping Emails",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Shipping Advice Mails",
          active: true,
        },
      ],
      resource: "Shipping Advice",
      action: "menu",
    },
  },
  {
    path: "/comex/envio-automatico",
    name: "envioautomatico",
    component: () => import("@/views/comex/envio_automatico.vue"),
    meta: {
      pageTitle: "Envio Automático",
      breadcrumb: [
        {
          text: "COMEX",
        },
        {
          text: "Envio de Correos Automático",
          active: true,
        },
      ],
      resource: "Shipping Advice",
      action: "menu",
    },
  },
];
